import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constants';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';
var moment = require('moment');

var SearchWorkspaceAction = function () {

}

SearchWorkspaceAction.prototype = {

	searchWorkspace: function (domainName,emailId) {
		restClient.searchWorkspace(domainName,emailId, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
				else{
					AppDispatcher.dispatch({
						actionType: Constant.SEARCH_WORKSPACE,
						data: error
					});
				}
			} else {
				if(response!=null){response['status'] = 200};
				AppDispatcher.dispatch({
					actionType: Constant.SEARCH_WORKSPACE,
					data: response
				});
			}
		})
	}
}

export default new SearchWorkspaceAction();